import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { DnDAreaState } from 'src/components/Uploader/DnDArea.state';

interface PropsType {
    label: string;
    onDrop: (files: File[]) => Promise<void>;
    allowedMimeTypes: string[];
}

export const DnDAreaV2 = observer((props: PropsType) => {
    const { onDrop, label, allowedMimeTypes } = props;

    const [state] = useState(() => new DnDAreaState(onDrop, allowedMimeTypes));

    return (
        <div
            className='border-dashed border-2 border-border w-full flex items-center justify-center mt-2 h-20'
            // isHighlighted={state.isFileOver}
            onDragEnter={state.highlightArea}
            onDragOver={state.highlightArea}
            onDragLeave={state.restoreArea}
            onDrop={state.handleDrop}
        >
            <span className='font-tertiary text-xs text-muted-foreground'>{label}</span>
        </div>
    );
});
